import * as React from 'react';

import { AppState } from 'common/models/AppState';
import { Redirect } from 'react-router-dom';

export interface DashboardProps {
  appState: AppState;
}

export interface DashboardState {}

export class Dashboard extends React.Component<DashboardProps, DashboardState> {
  render() {
    return <Redirect to="/users" />;
  }
}



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Dashboard.tsx